module.exports = __webpack_public_path__ + "static/media/CAL_BG.62e6dfb2.png";